const dd =[34400000 , 161000000 , 343000000 , 260000000 , 234000000 , 98000000, 234000000,121000000]
const chartData = {
    type: 'area',
    height: 104,
    options: {
        fill: {

        },
        chart: {
            id: 'support-chart',
            sparkline: {
                enabled: true
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 1
        },
        tooltip: {
            fixed: {
                enabled: false
            },
            x: {
                show: false
            },
            y: {
                title: 'Ticket '
            },
            marker: {
                show: false
            }
        }
    },
    series: [
        {
            name: 'تومان',
            data: dd,
        },
    ]
};

export default chartData;